export const SET_LOGED_ACTIVE = 'SET_LOGED_ACTIVE'